import React from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "../components/ScrollReveal";
import { getCopy, getCopyObject } from "../utils/copyUtils";

const ThankYouPage: React.FC = () => {
  // Get copy from JSON file
  const hero = getCopyObject<{ title: string; description: string }>("thank_you.hero");
  const content = getCopyObject<{
    title: string;
    description: string;
    back_button: string;
    questions_prefix: string;
    questions_text: string;
    email: string;
  }>("thank_you.content");

  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <ScrollReveal className="hero-content" direction="up" delay={200}>
            <h1 className="hero-title">{hero?.title}</h1>
            <p className="hero-description">{hero?.description}</p>
          </ScrollReveal>
        </div>
      </section>

      <main className="main">
        <div className="main__curved curved-ellipse"></div>
        <div className="main__curved-line curved-ellipse"></div>

        {/* Thank-you Section */}
        <section className="thank-you">
          <div className="thank-you-container container">
            <ScrollReveal direction="up" delay={300}>
              <div className="thank-you__image">
                <img src="/images/team-success.svg" alt="team success" />
              </div>
              <h2 className="thank-you__title">{content?.title}</h2>
              <p className="thank-you__text">{content?.description}</p>
              <Link to="/" className="thank-you__button btn btn-primary">
                {content?.back_button}
              </Link>
              <div className="thank-you__questions">
                <span>{content?.questions_prefix}</span>
                {content?.questions_text}
                <a href={`mailto:${content?.email}`}> {content?.email}</a>
              </div>
            </ScrollReveal>
          </div>
        </section>
      </main>
    </>
  );
};

export default ThankYouPage;
